import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonItem, IonItemDivider, IonLabel, IonRow, IonText, IonTextarea } from '@ionic/react';
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import HostConfig from '../HostConfig';
import Content from '../components/Content';
import PleaseLoginCard from '../components/PleaseLoginCard';
import { useProfile } from '../data/store/useProfile';
import { FreshIssue } from '../models/Issue';
import { IssueService } from '../services/IssueService';
import { usePageTitle } from '../util/sugar';


const Issue: React.FC = () => {

    const [title, setTitle] = useState("");
    const [transmitted, setTrasmitted] = useState(false);
    const [description, setDescription] = useState("");
    const { authorId, authenticated, ownerId } = useProfile();
    const { pathname } = useLocation();

    const makeReport = () => {
        if (authorId && ownerId) {
            const issue: FreshIssue = { authorId, ownerId, description, title, path: pathname };
            IssueService.transmit(issue).then(() => {
                setTrasmitted(true);
            })
        }
    }
    usePageTitle("Report an Issue");


    return (
        <Content className='background-wall'>
            <IonGrid>
                <IonRow>
                    <IonCol sizeMd="8" sizeLg="6" offsetMd="2" offsetLg="3">
                        {authenticated ? <IonCard>
                            {!transmitted ? <IonCardContent>
                                <IonItem>
                                    <IonLabel position="stacked" color="primary">Title</IonLabel>
                                    <IonTextarea aria-label="Issue title" onIonChange={(e) => setTitle(e.detail.value!)} placeholder={"What are you reporting?"} color='dark'></IonTextarea>
                                </IonItem>
                                <IonItem>
                                    <IonLabel position="stacked" color="primary">Description</IonLabel>
                                    <IonTextarea aria-label="Issue description" onIonChange={(e) => setDescription(e.detail.value!)} value={description} placeholder={"If you need group access, please include your email"} color='dark'></IonTextarea>
                                </IonItem>
                                <IonButton disabled={!description && !title} onClick={makeReport}>
                                    Transmit Report
                                </IonButton>
                            </IonCardContent> : <><IonCardHeader color="primary">
                                <IonCardTitle>
                                    Report Received!
                                </IonCardTitle>
                            </IonCardHeader><IonCardContent>

                                    <IonItemDivider color='clear' />
                                    <IonText>
                                        Thanks for helping us make {HostConfig.title} better!
                                    </IonText>
                                    <IonItemDivider color='clear' />
                                    <IonLabel color="danger">
                                        {title}
                                    </IonLabel>
                                    <IonItemDivider color='clear' />
                                    <IonText>
                                        {description}
                                    </IonText>
                                </IonCardContent></>}
                        </IonCard> : <PleaseLoginCard action=" to report an issue" />}
                    </IonCol>
                </IonRow></IonGrid>
        </Content>
    );
};

export default (Issue);